module.exports = __webpack_public_path__ + "img/marktingAddeb.eb9f2444.svg";